<template>
    <div id="studentlistreport">
        <div class="container admin-wrap">
            <div class="row header mb-5">
                <div class="col-lg-5 ">
                    <h3 class="text-left mb-3">Student List Report</h3>
                </div>
                <div class="col-lg-7">
                    <div class="row">
                        <el-select v-model="ddlSemester" placeholder="Select" style="margin-left:auto;">
                            <el-option
                                    v-for="item in semesterList"
                                    :key="item.PK_Semester_ID"
                                    :label="item.SMT_Code"
                                    :value="item.PK_Semester_ID">
                            </el-option>
                        </el-select>
                        <button type="button" class="btn btn-primary float-right" style="margin-left:10px;" v-on:click="generateReport()">Generate</button>
                    </div>
                </div>
            </div>
            <div class="pb-5">
                <div class="empty-list_image" v-if="studentListInt.length < 1">
                    <strong>{{startupText}}</strong>
                    <img src="../assets/notfound.png"/>
                </div>
                <div v-if="studentListInt.length > 0" class="datatable_group ClassAttendanceReportPage">

                  <form name="downloadReport" class="download-report">
                    <input v-model="password" required minlength="8" type="password" class="form-control" placeholder="password to unlock report">
                    <el-button :disabled="exporting" type="primary" round @click="exportExcel()" class="btnExport"><i class="fa fa-file-excel-o" aria-hidden="true"></i> {{ exporting ? 'Exporting...' : 'Export' }}</el-button>
                  </form>

                    <data-tables :data="studentListInt">
                        <el-table-column v-for="studentListInfo in studentList"
                                         :prop="studentListInfo.prop"
                                         :label="studentListInfo.label"
                                         :key="studentListInfo.prop"
                                         sortable="custom">
                        </el-table-column>
                    </data-tables>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DataSource from "../data/datasource";

    export default {
        name: "StudentListReport",
        data() {
            return {
                startupText: 'No Record...',
                semesterList: [],
                ddlSemester: '',
                password: '',
                exporting: false,

                studentListInt: [],
                studentList: [{
                    prop: "Student ID",
                    label: "Student ID"
                }, {
                    prop: "First Name",
                    label: "First Name"
                }, {
                    prop: "Middle Name",
                    label: "Middle Name"
                }, {
                    prop: "Last Name",
                    label: "Last Name"
                }, {
                    prop: "DOB",
                    label: "DOB"
                }, {
                    prop: "First Commencement Date",
                    label: "First Commencement Date"
                }, {
                    prop: "Local Residential Address",
                    label: "Local Residential Address"
                }, {
                    prop: "Billing Address",
                    label: "Billing Address"
                }, {
                    prop: "Current Level",
                    label: "Current Level"
                }, {
                    prop: "First Enroll Level",
                    label: "First Enroll Level"
                }, {
                    prop: "Class",
                    label: "Class"
                }, {
                    prop: "Current Commencement Date",
                    label: "Current Commencement Date"
                }, {
                    prop: "Status",
                    label: "Status"
                }, {
                    prop: "IC",
                    label: "IC"
                }, {
                    prop: "Birth Cert",
                    label: "Birth Cert"
                }, {
                    prop: "Fin",
                    label: "Fin"
                }, {
                    prop: "Fin Expiry Date",
                    label: "Fin Expiry Date"
                }, {
                    prop: "Passport",
                    label: "Passport"
                }, {
                    prop: "Passport Expiry Date",
                    label: "Passport Expiry Date"
                }, {
                    prop: "Nationality",
                    label: "Nationality"
                }, {
                    prop: "Residency Status",
                    label: "Residency Status"
                }, {
                    prop: "Gender",
                    label: "Gender"
                }, {
                    prop: "Father First Name",
                    label: "Father First Name"
                }, {
                    prop: "Father Middle Name",
                    label: "Father Middle Name"
                }, {
                    prop: "Father Last Name",
                    label: "Father Last Name"
                }, {
                    prop: "Father ID",
                    label: "Father ID"
                }, {
                    prop: "Father ID Expiry Date",
                    label: "Father ID Expiry Date"
                }, {
                    prop: "Father Email",
                    label: "Father Email"
                }, {
                    prop: "Father Local Residential Address",
                    label: "Father Local Residential Address"
                }, {
                    prop: "Mother First Name",
                    label: "Mother First Name"
                }, {
                    prop: "Mother Middle Name",
                    label: "Mother Middle Name"
                }, {
                    prop: "Mother Last Name",
                    label: "Mother Last Name"
                }, {
                    prop: "Mother ID",
                    label: "Mother ID"
                }, {
                    prop: "Mother ID Expiry Date",
                    label: "Mother ID Expiry Date"
                }, {
                    prop: "Mother Email",
                    label: "Mother Email"
                }, {
                    prop: "Mother Local Residential Address",
                    label: "Mother Local Residential Address"
                }, {
                    prop: "Additional Language",
                    label: "Additional Language"
                }, {
                    prop: "School Meal",
                    label: "School Meal"
                }, {
                    prop: "1st Emergency Contact",
                    label: "1st Emergency Contact"
                }, {
                    prop: "1st Emergency Contact No",
                    label: "1st Emergency Contact No"
                }, {
                    prop: "1st Emergency Relation",
                    label: "1st Emergency Relation"
                }, {
                    prop: "2nd Emergency Contact",
                    label: "2nd Emergency Contact"
                }, {
                    prop: "2nd Emergency Contact No",
                    label: "2nd Emergency Contact No"
                }, {
                    prop: "2nd Emergency Relation",
                    label: "2nd Emergency Relation"
                }, {
                    prop: "3rd Emergency Contact",
                    label: "3rd Emergency Contact"
                }, {
                    prop: "3rd Emergency Contact No",
                    label: "3rd Emergency Contact No"
                }, {
                    prop: "3rd Emergency Relation",
                    label: "3rd Emergency Relation"
                }, {
                    prop: "Medication Allergies",
                    label: "Medication Allergies"
                }, {
                    prop: "Food Allergies",
                    label: "Food Allergies"
                }, {
                    prop: "PayeeType",
                    label: "Payee Type"
                }, {
                    prop: "PayeeName",
                    label: "Payee Name"
                }, {    
                    prop: "FamilyNo",
                    label: "Family No"
                }, {                    
                    prop: "BusInNo",
                    label: "Bus In No"
                }, {
                  prop: "BusOutNo",
                  label: "Bus Out No"
                }],
              
            };
        },
        async created() {
            this.getAcademicYear();
        },
        methods: {
            async getAcademicYear() {
                try {
                    const response = await DataSource.shared.getAcademicYearWithClosedPastYear('');
                    if (response) {
                        if (response.code === '88') {
                            window.location.replace('/');
                        } else {
                            this.semesterList = response.Table;
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async generateReport() {
                try {
                    if (this.ddlSemester === '') {
                        this.$notify.error({
                            title: 'Required',
                            message: 'Please select Academic Year...'
                        });
                    } else {
                        this.$vs.loading();

                        const response = await DataSource.shared.getStudentListReport(this.ddlSemester);

                        if (response) {
                            if (response.code === '88') {
                                window.location.replace('/');
                            } else if (response.code === '99') {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Get Student List Report Error!'
                                });
                            } else if (response.code === '2') {
                                this.$notify({
                                    title: 'No Record',
                                    message: 'No Record Found...'
                                });
                            } else {
                                this.studentListInt = response.Table;
                            }
                        }

                        this.$vs.loading.close();
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async exportExcel () {
              if (!document.forms.downloadReport.reportValidity()) {
                return;
              }
              try {
                this.exporting = true;
                const response = await DataSource.shared.getStudentListReport(this.ddlSemester, this.password);
                if (response.message) this.$notify({ title: '', message: response.message });
              }
              finally {
                this.exporting = false;
              }
            },
        },
    }
</script>

<style scoped>
    .btnExport {
        display: block;
    }

    .download-report {
      display: flex;
      gap: 12px;
    }

    @media (max-width: 769px) {
      .download-report {
        flex-direction: column;
      }
    }

    .download-report .form-control {
      margin-bottom: 0;
      max-width: 300px;
    }
</style>